import React from 'react';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import AppRouter from './routes';
import ErrorBoundary from './components/common/ErrorBoundary';
import ToastContainer from './components/common/Toast';
import LoadingSpinner from './components/common/LoadingSpinner';
import { CompanyProvider } from './contexts/CompanyContext';
import { useAuthInitialization, useTokenRefresh } from './stores/authStore';
import './utils/authDebug'; // Carregar ferramentas de debug
import './utils/authFix'; // Carregar correção automática de cache

// Criar QueryClient instance
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutos
      retry: 1,
      refetchOnWindowFocus: false,
    },
  },
});

function App() {

  // Inicialização da autenticação
  const isInitialized = useAuthInitialization();
  
  // Auto-refresh de tokens
  useTokenRefresh();

  // Se ainda não inicializou, mostrar loading
  if (!isInitialized) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="text-center">
          <LoadingSpinner size="large" className="mb-4" />
          <p className="text-gray-600">Inicializando aplicação...</p>
        </div>
      </div>
    );
  }

  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <CompanyProvider>
          <AppRouter />
          <ToastContainer />
          <Toaster
            position="top-right"
            toastOptions={{
              duration: 4000,
              style: {
                background: 'var(--color-text-primary)',
                color: 'var(--color-text-inverse)',
              },
              success: {
                style: {
                  background: 'var(--color-status-success)',
                },
              },
              error: {
                style: {
                  background: 'var(--color-status-danger)',
                },
              },
            }}
          />
        </CompanyProvider>
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
